<template>
  <!-- 班级 在线答疑，模拟器训练，iep学习详情 -->
  <div class="my-details">
    <van-skeleton v-if="loadingSke" title :row="3" />
    <template v-else>
      <div class="head">
        <div class="head-box">
          <div class="left">
            <img src="../../assets/images/grade/home-iep.png" alt="" v-if="details.type === 6">
            <img src="../../assets/images/grade/home-answer.png" alt="" v-if="details.type === 7">
            <img src="../../assets/images/grade/home-mock.png" alt="" v-if="details.type === 8">
            <img src="../../assets/images/grade/icon-examine.png" alt="" v-if="details.type === 9">
            <p class="head-title">{{ typeTitle[details.type] }}</p>
          </div>
          <div class="head-group" @click="handleSet" v-if="details && details.isCreator">
            <span class="group-set">设置</span>
            <img src="../../assets/images/grade/icon-setting.png" alt="">
          </div>
          <div class="group-box" v-if="isGroupSet">
            <div class="group-menu" @click="handleEdit">
              <img src="../../assets/images/grade/icon-edit-white.png" alt="">
              <span class="title">编辑</span>
            </div>
            <div class="group-menu" @click="handleDel">
              <img src="../../assets/images/grade/icon-del-white.png" alt="">
              <span class="title">删除</span>
            </div>
          </div>
        </div>
      </div>
      <div class="main" :class="commonPer && details.isConfirm === 0 ? 'main100' : ''">
        <ul class="item">
          <li class="item-li" v-if="details.type === 7">
            <p class="label">主题:</p>
            <div class="value">
              <p class="value-title">{{ details && details.goal }}</p>
            </div>
          </li>
          <li class="item-li" v-if="[6, 7, 9].includes(details.type)">
            <p class="label">内容:</p>
            <div class="value">
              <p class="value-title" v-html="details.classContent"></p>
            </div>
          </li>
          <li class="item-li" v-if="details.type === 8">
            <p class="label">类型:</p>
            <div class="value">
              <p class="value-title">{{ details && details.simulatorName }}</p>
            </div>
          </li>
          <li class="item-li">
            <p class="label">时间:</p>
            <div class="value">
              <p class="value-title">{{ details && details.dataTime }}</p>
            </div>
          </li>
          <li class="item-li" v-if="[6, 8].includes(details.type)">
            <p class="label">地点:</p>
            <div class="value">
              <p class="value-title">{{ details && details.place }}</p>
            </div>
          </li>
          <li class="item-li" v-if="[6, 8].includes(details.type)">
            <p class="label">目标:</p>
            <div class="value">
              <p class="value-title">{{ details && details.goal }}</p>
            </div>
          </li>
          <li class="item-li">
            <p class="label">其他:</p>
            <div class="value">
              <p class="value-title" v-html="details.other"></p>
            </div>
          </li>
          <li class="item-li" v-if="[7].includes(details.type)">
            <p class="label">链接:</p>
            <div class="value" v-if="details.type === 7">
              <div class="flex-val">
                <div class="btn" v-track="{ functionName: '班级-进入会议' }" @click="handleGoMeeting(details.onlineLink)">进入会议</div>
                <p class="val-title">{{ meetingStatusList[details.meetingStatus] }}</p>
              </div>
            </div>
          </li>
          <li class="item-li" v-if="[9].includes(details.type)">
            <p class="label">考试题目:</p>
            <div class="value">
              <div class="flex-val">
                <div class="btn" v-track="{ functionName: '进入班级考试' }" @click="handleGoAnswer">进入考试</div>
              </div>
            </div>
          </li>
          <li class="item-li" v-if="[9].includes(details.type)">
            <p class="label">最多答题次数:</p>
            <div class="value">
              <p class="value-title">{{ details.inspectNum || '不限' }}</p>
            </div>
          </li>
        </ul>
        <template v-if="details.studyContents && details.studyContents.length > 0">
          <div class="link">
            <img src="../../assets/images/grade/details-link.png" alt="" class="icon-link">
            <p class="link-title" v-if="details.type === 9">关联课程</p>
            <p class="link-title" v-else>关联内容</p>
          </div>
          <ul class="menu-case">
            <li class="case-li" v-for="(item, index) in details.studyContents" :key="index"
              @click.stop="handleDialogUnlock(item, index)">
              <div class="item-cover">
                <img :src="item.cover || item.docuCourseCase && item.docuCourseCase.coverUrl" alt="" class="cover" />
                <div class="item-tag">{{ contentType[item.type] }}</div>
              </div>
              <div class="right">
                <template v-if="[2, 3].includes(item.type)">
                  <p class="title title1">{{ item && item.title }}</p>
                  <p class="teacher">讲师：{{ item.docuCourseCase && item.docuCourseCase.keynoteSpeaker }}</p>
                  <p class="hospital">{{ item.docuCourseCase && item.docuCourseCase.hospitalName }}</p>
                </template>
                <template v-if="item.type === 1">
                  <p class="title"
                    :class="`${item.docuCourseCase && item.docuCourseCase.isUnlock}` === '1' && !item.docuCourseCase && item.docuCourseCase.myUnlock ? 'title1' : 'title2'">
                    {{ item && item.title }}</p>
                </template>
                <div class="item-unlock"
                  v-if="`${item.docuCourseCase && item.docuCourseCase.isUnlock}` === '1' && !item.docuCourseCase.myUnlock">
                  <img src="@/assets/images/grade/icon-suo.png" class="icon-unlock" alt="">
                  <span class="txt">可使用{{ item.docuCourseCase && item.docuCourseCase.unlockCost }}积分兑换</span>
                </div>
              </div>
            </li>
          </ul>
        </template>
        <template v-if="details.postGroups && details.postGroups.length">
          <div class="link">
            <img src="../../assets/images/grade/icon-group-red.png" alt="" class="icon-group">
            <p class="link-title">接收小组</p>
          </div>
          <ul class="menu-group">
            <li class="group-li" v-for="(item, index) in details.postGroups" :key="index">
              <img src="../../assets/images/grade/select.png" alt="" class="img" v-if="item.isSelected">
              <img src="../../assets/images/grade/no-select.png" v-else class="img" alt="">
              <p class="title">{{ item.groupName }}</p>
            </li>
          </ul>
        </template>
        <template v-if="details.confirmUsers && details.confirmUsers.length > 0">
          <div class="link">
            <img src="../../assets/images/grade/select.png" alt="" class="icon-select">
            <p class="link-title">已确认</p>
          </div>
          <ul class="menu-user">
            <li class="user-li" v-for="(item, index) in details.confirmUsers" :key="index">
              <img :src="item.userInfo.headPicUrl" alt="" class="img">
              <div class="right">
                <div class="right-head">
                  <p class="title">{{ item.userInfo.realName }}</p>
                  <div class="group-right">
                    <div class="group-box" v-if="item.groupName && item.groupName !== 'CLASS_UNGROUPED_MARK_IT'">{{
                      item.groupName }}</div>
                  </div>
                </div>
                <p class="hospital">{{ item.userInfo.hospitalName }}</p>
              </div>
            </li>
          </ul>
        </template>
        <ExamSituation :class-id="classId" :postbar-id="postId" v-if="userInfo.memberType == 1 && details.type === 9"/>
      </div>
      <button class="confirm-button" @click="handleOk" v-if="commonPer && details.isConfirm === 0">通知确认</button>
      <dialogUnlock ref="dialogUnlock" @unlockSuccess="handleJump" :dataProps="dataProps"></dialogUnlock>
      <dialogDel ref="dialogDel" @handleDelSave="handleDelSave" :dialogHeadTxt="dialogHeadTxt" :delMessage="delMessage" @handleClose="handleDelClose"></dialogDel>
    </template>
  </div>
</template>

<script>
import dialogUnlock from '@/components/dialogUnlock.vue'
import { meetingStatusList, contentType, typeTitle } from './data'
import { setSha, traceClickURL } from '../../utils/util'
import { postCardDetails, userConfirm, delClassCard } from '@/api/grade'
import { debounce } from '@/utils/util'
import dialogDel from './components/dialogDel.vue'
import ExamSituation from './components/ExamSituation.vue'
import {isScorm} from '../../api/scorm'
// import { getShareInfo } from '@/utils/wxShare'
export default {
  name: 'gradeDetail',
  components: {
    ExamSituation,
    dialogUnlock,
    dialogDel
  },
  data () {
    return {
      classId: '',
      commonPer: false,
      typeTitle,
      contentType,
      details: {},
      dataDetails: {},
      postId: '',
      meetingStatusList,
      dataProps: {
        unlockContent: '兑换班级课程',
        unlockTxt: '课程'
      },
      isGroupSet: false,
      loadingSke: true,
      delMessage: '确认删除吗?',
      dialogHeadTxt: '提示'
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
  },
  created () {
    this.postId = this.$route.query.postId
    this.classId = this.$route.query.classId
    this.commonPer = this.$route.query.commonPer && JSON.parse(this.$route.query.commonPer)
    this.postId && this.handleLoad()
    // this.handleShareMethod()
  },
  methods: {
    handleGoAnswer () {
      sessionStorage.setItem('traceObj', JSON.stringify({
        functionUrl: '/gradeQuestion',
        note: `postId=${this.postId}&classId=${this.classId}`
      }))
      if (this.details.userInspectBusiness) {
        this.$router.push({
          path: '/gradeQuestion',
          query: {
            postbarId: this.postId,
          }
        })
      } else if (this.details.userInspectComplete) {
        this.$router.push({
          path: '/gradeQuestion',
          query: {
            postbarId: this.postId,
            noneHasResult: true
          }
        })
      } else {
        this.dialogHeadTxt = '进入考试'
        const str = this.details.userResidueInspectNum >= 0 ? `, 还剩<span style="color: #EB1700;">${this.details.userResidueInspectNum}</span>次！` : ''
        this.delMessage = `您好，您本场考试的答题次数为第${this.details.userInspectNum}次${str}`
        this.$refs.dialogDel.init({ id: this.postId })
        this.dialogConType = 'gradeQuestion'
      }
    },
    handleOk: debounce(function () {
      const params = {
        classId: this.classId,
        postbarId: this.details.id,
        userId: this.userInfo.id
      }
      userConfirm(params).then(res => {
        this.$toast('通知确认成功')
        this.commonPer = false
        this.handleLoad()
      }).catch(err => {
        this.$toast(err.msg)
      })
    }, 500),
    async handleJump () {
      window.sessionStorage.setItem('entrance', '55')
      let item = this.dataDetails
      // let openid = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      let trackParams = `&entrance=55&businessChannel=55&campId=${this.classId}`
      let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      // let iepTxt = `&nickname=123&avatar=123&subscribe=1`
      if (item.type === 1) {
        this.$router.push({
          path: '/articleDetails',
          query: {
            id: item.baseId,
            classId: this.classId,
            businessId: this.classId,
            entrance: '55',
            channel: '55'
          }
        })
        // setTimeout(() => { traceClickURL() })
        // window.location.href = `${process.env.iepUrl}/mobile/home/article-detail?index=0&id=${item.docuCourseCase.baseId}${openid}${iepTxt}${trackParams}`
      } else if (item.type === 3) {
        setTimeout(() => { traceClickURL() })
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.docuCourseCase.baseId}${openidBindli}${trackParams}`
      } else if (item.type === 2) {
        const query = {
          courseId: item.docuCourseCase.baseId,
          classId: this.classId,
          businessId: this.classId,
          entrance: '55',
          channel: '55'
        }
        const isscorm = await isScorm(item.docuCourseCase.baseId)
        let path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
        this.$router.push({path, query})
      }
    },
    // 解锁
    handleDialogUnlock (item, index) {
      this.curIndex = index
      this.dataDetails = item
      if (item.docuCourseCase && `${item.docuCourseCase.isUnlock}` === '1' && !item.docuCourseCase.myUnlock) {
        this.dataProps.baseId = item.docuCourseCase.baseId
        this.dataProps.unlockCost = item.docuCourseCase.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      this.handleJump()
    },
    // 进入会议
    handleGoMeeting (onlineLink) {
      sessionStorage.setItem('traceObj', JSON.stringify({
        functionUrl: onlineLink,
        note: `postId=${this.postId}&classId=${this.classId}`
      }))
      window.open(onlineLink)
    },
    handleLoad () {
      postCardDetails(this.postId).then(res => {
        const data = res.data
        console.log(data.sameGroup, '2222')
        if (data.sameGroup || this.userInfo.memberType === 1) {
          this.loadingSke = false
        } else {
          this.$toast('暂无权限查看，回到班级主页')
          this.$router.push({
            path: '/gradeHomePage',
            query: {
              classId: this.classId
            }
          })
          return
        }
        if (data.studyContents && data.studyContents.length > 0) {
          data.studyContents.forEach(acc => {
            acc.createTime = this.$moment(data.createTime * 1).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          })
        }
        let startTime = this.$moment(data.startTime * 1).format(
          'YYYY-MM-DD HH:mm'
        )
        let endTime = this.$moment(data.endTime * 1).format(
          'YYYY-MM-DD HH:mm'
        )
        data.dataTime = `${startTime} ~ ${endTime}`
        this.details = data
      })
    },
    handleSet () {
      this.isGroupSet = true
    },
    handleDel () {
      this.dialogHeadTxt = '提示'
      this.delMessage = `确认删除吗?`
      this.$refs.dialogDel.init({ id: this.postId })
    },
    handleEdit () {
      const list = {
        6: '/gradeIep',
        7: '/gradeAnswer',
        8: '/gradeMock',
        9: '/gradeExamine'
      }
      sessionStorage.removeItem('changeCourseCon')
      this.$router.push({
        path: `${list[this.details.type]}?areaId=${this.classId}&postId=${this.postId}`
      })
    },
    handleDelClose () {
      this.isGroupSet = false
    },
    handleDelSave () {
      if (this.dialogConType === 'gradeQuestion') {
        this.$router.push({
          path: '/gradeQuestion',
          query: {
            postbarId: this.postId,
            noneHasResult: true
          }
        })
        return
      }
      delClassCard(this.postId, { isShow: 0 }).then(res => {
        this.$toast('删除成功')
        // this.$refs.dialogDel.init()
        this.isGroupSet = false
        this.$router.back()
      }).catch(err => {
        this.$toast(err.msg)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.my-details {
  position: relative;
  background: #F9F8F7;
  display: flex;
  flex-direction: column;

  .head {
    width: 100%;
    height: 64px;
    position: relative;
    padding: 20px 12px 16px;
    box-sizing: border-box;

    .head-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 24px;

      .left {
        display: flex;
        align-items: center;

        img {
          width: 24px;
          height: 24px;
          margin-right: 6px;
        }

        .head-title {
          font-weight: 600;
          font-size: 16px;
          line-height: 24px;
          color: #202020;
        }
      }

      .head-group {
        display: flex;
        align-items: center;
        position: relative;

        .group-set {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          margin-right: 4px;
        }

        img {
          width: 14px;
          height: 15px;
          position: relative;
        }

      }

      .group-box {
        position: absolute;
        z-index: 2;
        right: 8px;
        top: 46px;
        width: 83px;
        height: 88px;
        background: rgba(0, 0, 0, 0.8);
        border-radius: 8px 8px 8px 8px;
        padding: 16px 22px 16px 12px;
        box-sizing: border-box;

        .group-menu {
          position: relative;
          display: flex;
          align-items: center;

          &:last-child {
            margin-top: 16px;
          }

          img {
            width: 13px;
            height: 13px;
            margin-right: 3px;
          }

          .title {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
          }
        }
      }
    }
  }

  .main {
    padding: 15px 16px 30px;
    height: calc(100vh - 64px - 45px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    background-color: #FFF;

    .item {
      position: relative;
      width: 100%;
      margin-bottom: 24px;

      .item-li {
        display: flex;
        align-items: baseline;
        position: relative;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }

        .label {
          font-weight: 500;
          font-size: 14px;
          color: #7A8494;
          margin-right: 6px;
        }

        .value {
          flex: 1;

          .value-title {
            width: 100%;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            word-wrap: break-word;
            word-break: break-all;
          }

          .flex-val {
            display: flex;
            align-items: baseline;

            .btn {
              width: 89px;
              height: 32px;
              background: #EB1700;
              border-radius: 25px;
              margin-right: 10px;
              font-size: 12px;
              color: #FFFFFF;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            .val-title {
              font-weight: 500;
              font-size: 14px;
              color: #7A8494;
            }
          }

        }
      }
    }

    .link {
      position: relative;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #E8E8E8;
      padding-bottom: 10px;

      .icon-link {
        width: 21px;
        height: 14px;
        margin-right: 2px;
      }

      .icon-group {
        width: 18px;
        height: 18px;
        margin-right: 2px;
      }

      .link-title {
        font-weight: 500;
        font-size: 14px;
        color: #EB1700;
      }
    }

    .icon-select {
      width: 16px;
      height: 16px;
      margin-right: 2px;
    }

    .menu-case {
      margin-top: 10px;
      position: relative;
      margin-bottom: 14px;

      .case-li {
        width: 100%;
        min-height: 89px;
        background: #F9F9F9;
        border-radius: 4px;
        display: flex;
        padding: 10px;
        box-sizing: border-box;
        margin-bottom: 14px;

        &:last-child {
          margin-bottom: 0;
        }

        .item-cover {
          width: 103px;
          min-width: 103px;
          object-fit: cover;
          position: relative;
          border-radius: 4px;
          margin-right: 8px;
          height: 68px;
          border-radius: 4px;

          .cover {
            display: block;
            width: 100%;
            object-fit: cover;
            height: 68px;
            border-radius: 4px;
          }

          .item-tag {
            font-size: 12px;
            position: absolute;
            line-height: 16px;
            border-top-right-radius: 8px;
            color: #000000;
            background-color: rgba(255, 255, 255, .6);
            padding: 2px;
            box-sizing: border-box;
            padding: 0 4px;
            height: 16px;
            bottom: 0;
            left: 0
          }
        }

        .right {
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow: hidden;

          .title {
            font-weight: 500;
            font-size: 14px;
            color: #000000;
          }

          .title2 {
            overflow: hidden; //溢出内容隐藏
            text-overflow: ellipsis; //文本溢出部分用省略号表示
            display: -webkit-box; //特别显示模式
            -webkit-line-clamp: 2; //行数
            line-clamp: 2;
            -webkit-box-orient: vertical; //盒子中内容竖直排列
          }

          .title1 {
            white-space: nowrap;
            overflow: hidden; //溢出内容隐藏
            text-overflow: ellipsis; //文本溢出部分用省略号表示
          }

          .teacher,
          .hospital {
            margin-top: 2px;
            font-size: 14px;
            color: #7A8494;
          }

          .item-unlock {
            display: flex;
            align-items: center;
            height: 20px;
            margin-top: 2px;

            .icon-unlock {
              width: 10px;
              margin-right: 4px;
              display: block;
            }

            .txt {
              color: #EB1700;
              font-size: 12px;
            }
          }
        }
      }
    }

    .menu-user {
      margin-top: 10px;
      position: relative;
      margin-bottom: 14px;

      .user-li {
        width: 100%;
        height: 62px;
        background: #F9F9F9;
        border-radius: 4px;
        display: flex;
        align-items: center;
        padding: 10px;
        box-sizing: border-box;
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: 0;
        }

        .img {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          margin-right: 6px;
        }

        .right {
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow: hidden;

          .right-head {
            display: flex;
            align-items: center;

            .title {
              font-weight: 500;
              font-size: 14px;
              color: #000000;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            .group-right {
              flex: 1;
              display: flex;
              overflow: hidden;

              .group-box {
                height: 13px;
                box-sizing: border-box;
                position: relative;
                border: 1px solid #EB1700;
                border-radius: 2px;
                padding: 0 6px;
                font-family: Source Han Sans CN, Source Han Sans CN;
                font-weight: 500;
                font-size: 10px;
                line-height: 12px;
                color: #EB1700;
                margin-left: 4px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

          }

          .hospital {
            margin-top: 2px;
            font-size: 14px;
            color: #7A8494;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }

    .menu-group {
      margin-top: 10px;
      position: relative;
      margin-bottom: 14px;

      .group-li {
        width: 100%;
        height: 18px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        margin-bottom: 18px;
        overflow: hidden;
        white-space: nowrap;

        &:last-child {
          margin-bottom: 0;
        }

        .img {
          width: 18px;
          height: 18px;
          margin-right: 10px;
        }

        .title {
          font-weight: 500;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.6);
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

  }

  .main100 {
    height: calc(100vh - 64px - 107px);
  }

  .confirm-button {
    height: 42px;
    margin: 0 10px;
    width: calc(100% - 20px);
    background-color: #EB1700;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 42px;
    box-sizing: border-box;
    border: none;
    border-radius: 22px;
    text-align: center;
    cursor: pointer;
  }
}</style>



// WEBPACK FOOTER //
// src/views/grade/gradeDetail.vue